// theme/customizations/listItemIcon.js

export const listItemIconCustomizations = {
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        color: "white", // Network Rail orange
        minWidth: 40, // optional: aligns icons nicely
        justifyContent: "center",
      },
    },
  },
};
